import {useJbHttpCrudService} from "../../core/service/jb-http-crud.service";
import {SupplierEntity} from "../entity/supplier.entity";

export function useSupplierRepository() {
  const crud = useJbHttpCrudService<SupplierEntity>('supplier');
  
  return {
    ...crud,
  }
}